import type { RootState } from '..';

export const selectFetchConsumerUnitLoading = (state: RootState) =>
  state.consumerUnit.fetchLoading;

export const selectListConsumerUnitLoading = (state: RootState) =>
  state.consumerUnit.listLoading;

export const selectCreateConsumerUnitLoading = (state: RootState) =>
  state.consumerUnit.createLoading;

export const selectUpdateConsumerUnitLoading = (state: RootState) =>
  state.consumerUnit.updateLoading;

export const selectUpdateImageLoading = (state: RootState) =>
  state.consumerUnit.updateImageLoading;

export const selectDeleteConsumerUnitLoading = (state: RootState) =>
  state.consumerUnit.deleteLoading;

export const selectRefreshConsumerUnit = (state: RootState) =>
  state.consumerUnit.refresh;

export const selectSelectedConsumerUnitIds = (state: RootState) =>
  state.consumerUnit.selectedConsumerUnitIds;

export const selectConsumerUnitRemoved = (state: RootState) =>
  state.consumerUnit.consumerUnitDeleted;

export const selectConsumerUnitUpdated = (state: RootState) =>
  state.consumerUnit.consumerUnitUpdated;

export const selectConsumerUnit = (state: RootState) =>
  state.consumerUnit.consumerUnit;

export const selectConsumerUnitList = (state: RootState) =>
  state.consumerUnit.consumerUnitList;

export const selectConsumerUnitInvoices = (state: RootState) =>
  state.consumerUnit.consumerUnitInvoiceList;

export const selectConsumerUnitError = (state: RootState) =>
  state.consumerUnit.error;
